export default __webpack_public_path__ + "8a718ae45f324013ef76fbdf8e419e43.jpg";